exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search{width:276px;padding:10px}.table{width:calc(100vw - 276px - 17px)}.search,.table{float:left;height:100vh}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./src/trader/trader.scss
 ** module id = 289
 ** module chunks = 0
 **/